import {useAuthUserStore} from "@/stores/auth";

// PUT /academy/colors necesita siempre los tres: sin brand_color o text_color
// responde 500, y sin theme_header_block devuelve la home al encabezado por defecto.
const COLOR_FIELDS = ['brand_color', 'text_color', 'theme_header_block']

export default {
    index(academyUuid) {
        return useAuthUserStore().getApiClient.get('/academy/colors', {
            params: {
                academy_uuid: academyUuid
            }
        })
    },

    update(academyUuid, data)
    {
        return useAuthUserStore().getApiClient.put('/academy/colors', data, {
            params: {
                academy_uuid: academyUuid
            }
        })
    },

    /*
     * Guarda solo `fields` (p. ej. {brand_color}) sin pisar los demás: relee los
     * valores guardados justo antes y envía los tres. Así dos pantallas que editan
     * campos distintos (Diseño y Portada) no se borran entre sí.
     */
    async updateFields(academyUuid, fields)
    {
        const {data: saved} = await this.index(academyUuid)
        const payload = {}

        COLOR_FIELDS.forEach((field) => {
            payload[field] = field in fields ? fields[field] : (saved[field] ?? '')
        })

        return this.update(academyUuid, payload)
    }
}